<template>
  <v-row dense class="pa-2">
    <!-- عنوان دکمه اپلیکیشن -->
    <v-col cols="12" md="6">
      <v-text-field
        v-model="data.appButtonText"
        label="متن دکمه ورود به اپلیکیشن"
        placeholder="ورود به اپلیکیشن روبیکا"
        outlined
        dense
      />
    </v-col>

    <!-- عنوان دکمه نسخه وب -->
    <v-col cols="12" md="6">
      <v-text-field
        v-model="data.webButtonText"
        label="متن دکمه نسخه وب"
        placeholder="مشاهده در نسخه وب روبیکا"
        outlined
        dense
      />
    </v-col>

    <!-- هدایت در دسکتاپ -->
    <v-col cols="12">
      <v-radio-group v-model="data.desktopAction" row dense>
        <v-radio
          label="نمایش لندینگ اختصاصی در دسکتاپ"
          value="landing"
          color="#7c25c7"
        />
        <v-radio
          label="انتقال مستقیم به نسخه تحت وب (web.rubika.ir)"
          value="direct_web"
          color="#e52d8c"
        />
      </v-radio-group>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "RobikaActions",
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>
